import { render, staticRenderFns } from "./ClassNav.vue?vue&type=template&id=4bbd7b2c&"
import script from "./ClassNav.vue?vue&type=script&lang=js&"
export * from "./ClassNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bbd7b2c')) {
      api.createRecord('4bbd7b2c', component.options)
    } else {
      api.reload('4bbd7b2c', component.options)
    }
    module.hot.accept("./ClassNav.vue?vue&type=template&id=4bbd7b2c&", function () {
      api.rerender('4bbd7b2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/ClassNav.vue"
export default component.exports